import './App.css'
import * as React from 'react';
import { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Map from './components/Map';
import Grid from "@material-ui/core/Grid";
import DataPanel from './components/DataPanel';
import LegendPanel from './components/LegendPanel';
import AttribPanel from './components/AttribPanel';
import MapTitle from './components/MapTitle';

const drawerWidth = 240;


export default function App(props) {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            {/* <AppBar
                position="fixed"
                sx={{
                    width: { sm: `calc(100%)` },// - ${drawerWidth}px
                    ml: { sm: `${drawerWidth}px` },
                }}
            >
                <Toolbar>

                    <Grid
                        justifyContent="space-between" // Add it here :)
                        container
                        spacing={2}
                    >
                        <Grid item>
                            <Typography variant="h6" noWrap component="div">
                                Map
                            </Typography>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar> */}
            
            <Box
                component="main"
                sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100%)` }}}// - ${drawerWidth}px
                style={{padding:0}}
            >
                {/* <Toolbar /> */}
                <Map />
                <div style={{zIndex: 501, position: 'absolute', top: 15, left: 15, paddingRight:15}}>
                    <DataPanel key="dp" />
                </div>
                { <div style={{zIndex: 499, position: 'absolute', bottom: 20, right: 20}}>
                    <LegendPanel />
                </div> }
                { <div style={{zIndex: 500, position: 'absolute', top: 15, left: 65, paddingRight:15, marginRight:35}}>
                    <AttribPanel />
                </div> }
                { <div style={{zIndex: 498, position: 'absolute', top: 15, left: 115, paddingRight:15}}>
                    <MapTitle />
                </div> }
            </Box>
        </Box>

);

}

